import { useInfiniteQuery } from "react-query";
import { DashboardQuery, DashboardReservasSubtenants } from "../typings";
import axios from "infra/http";
import { StatusReservaEnum } from "core/features/reservas/typings";

export function useDashboardReservasSubtenants(
  params: DashboardQuery & {
    tenantsIds: string[];
    statusId?: StatusReservaEnum | "";
  }
) {
  return useInfiniteQuery(
    [
      `/v1/dashboards/principal/reservas/subtenants-${params.dataFim}-${params.dataInicio}-${params.updatedAt}`,
      params.tenantsIds,
      params.statusId,
    ],
    async ({ pageParam }) => {
      const { data } = await axios.get<DashboardReservasSubtenants>(
        "/v1/dashboards/principal/reservas/subtenants",
        {
          params: {
            ...params,
            page: pageParam ?? 1,
          },
        }
      );

      return data;
    },
    {
      getNextPageParam: (lastPage) =>
        lastPage.meta.currentPage === lastPage.meta.totalPages
          ? undefined
          : lastPage.meta.currentPage + 1,
    }
  );
}
